// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.7,5.3C16,2.2,12,1.1,8.9,2.8s-4.3,5.7-2.5,8.8L12,22l5.7-10.4c0.5-1,0.8-2,0.8-3.1S18.2,6.3,17.7,5.3z M16.8,11.1 L12,19.9l-4.8-8.8c-0.5-0.8-0.7-1.7-0.7-2.7C6.5,5.4,9,3,12,3s5.5,2.5,5.5,5.5C17.5,9.4,17.3,10.3,16.8,11.1z" />
  <path d="m 8.7660389,7.5928086 h 6.6374731 c 0.312351,0 0.624703,0.3 0.624703,0.8 v 0 c 0,0.4 -0.234263,0.8 -0.624703,0.8 H 8.7660389 c -0.3904396,-0.1 -0.6247033,-0.5 -0.6247033,-0.9 v 0 c 0,-0.4 0.2342637,-0.7 0.6247033,-0.7 z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-map-marker-minus-71sRe33Y.js.map
